import { createFileRoute } from '@tanstack/react-router'
import JobsSubmissions from '@/pages/clients/components/jobs-submissions'

export const Route = createFileRoute('/_authenticated/clients/$clientId/')({
  component: JobsSubmissions,
})
